import { render, staticRenderFns } from "./H2.vue?vue&type=template&id=f7bb8354&scoped=true&lang=pug&"
import script from "./H2.vue?vue&type=script&lang=ts&"
export * from "./H2.vue?vue&type=script&lang=ts&"
import style0 from "./H2.vue?vue&type=style&index=0&id=f7bb8354&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bb8354",
  null
  
)

export default component.exports